import fr from '../assets/images/bonus-island/bonus-fr.png';
import de from '../assets/images/bonus-island/bonus-de.png';
import ar from '../assets/images/bonus-island/bonus-ar.png';
import en from '../assets/images/bonus-island/bonus-en.png';
import es from '../assets/images/bonus-island/bonus-es.png';
import fa from '../assets/images/bonus-island/bonus-fa.png';
import hi from '../assets/images/bonus-island/bonus-hi.png';
import hy from '../assets/images/bonus-island/bonus-hy.png';
import ka from '../assets/images/bonus-island/bonus-ka.png';
import ko from '../assets/images/bonus-island/bonus-ko.png';
import pt from '../assets/images/bonus-island/bonus-pt.png';
import ru from '../assets/images/bonus-island/bonus-ru.png';
import tr from '../assets/images/bonus-island/bonus-tr.png';
import uk from '../assets/images/bonus-island/bonus-uk.png';
import zh from '../assets/images/bonus-island/bonus-zh.png';
import zs from '../assets/images/bonus-island/bonus-zs.png';
import { AppDefaultValuesEnum } from '../enums';

const imagesSourceMap = { fr, de, ar, en, fa, hi, es, hy, ka, ko, pt, ru, tr, uk, zh, zs };

export const getBonusIslandImageSource = (lan) => {
  return imagesSourceMap[lan] || imagesSourceMap[AppDefaultValuesEnum.LANGUAGE];
};
